export let octoberUppercase = "sGMIUe";
export default {octoberUppercase};